import React from 'react'

export default function Seventh() {
return (
<>
    <div className="video-wrap">
        <img src="assets/img/dubai.jpeg" alt="" onContextMenu={(e) => e.preventDefault()} onDragStart={(e) => e.preventDefault()} />
    </div>
</>
)
}
